import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

/**
 * What failed per game: the currencies (game and currency, counted once) and
 * their games, and the games that failed without a currency, e.g. their
 * currency list could not be stored. A game counted by its currencies is not
 * counted again without one.
 */
export const getGameFailureCounts = (failures: FreeSpinsSyncFailure[]): GameFailureCounts => {
  const currencies = new Set<string>();
  const gamesWithCurrencies = new Set<number>();
  const gamesWithoutCurrency = new Set<number>();

  failures.forEach(({ gameId, gameCode, currency }) => {
    // The table and its count only take a game with both an id and a code.
    if (gameId === undefined || gameCode === undefined) return;
    if (currency === undefined) {
      gamesWithoutCurrency.add(gameId);
      return;
    }
    currencies.add(`${gameId}|${currency}`);
    gamesWithCurrencies.add(gameId);
  });

  gamesWithCurrencies.forEach((gameId) => gamesWithoutCurrency.delete(gameId));

  return {
    currencies: currencies.size,
    gamesWithCurrencies: gamesWithCurrencies.size,
    gamesWithoutCurrency: gamesWithoutCurrency.size,
  };
};

interface GameFailureCounts {
  currencies: number;
  gamesWithCurrencies: number;
  gamesWithoutCurrency: number;
}
